import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/creators/{creatorSlug}/members']['GET'];

const getMembers = async ({
  creatorSlug,
  page,
  perPage,
  search,
  filter,
  status,
  sort,
  withNames,
}: ThisApi['params'] & ThisApi['query']): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get<ThisApi['response']>(`/creators/${creatorSlug}/members`, {
    params: {
      filter,
      page,
      perPage,
      search,
      sort,
      status,
      withNames,
    },
  });
  return response.data as ThisApi['response'];
};

export default getMembers;
